import React from 'react'
import SideBar from '../components/common/SideBar'
import Header from '../components/common/Header'
import SubjectAssignmentsLatest from '../components/course/SubjectAssignmentsLatest'
import { useHistory } from 'react-router-dom'
import MyAssessmentList from '../components/myAssessments/MyAssessmentList'
import PageHeader from '../components/common/GlobalElements/PageHeader'

const MyAssessment = () => {
    const history = useHistory()

    const viewAssignment = (id, action) => {
        console.log("id, action",id, action)
        history.push(`/myassessments/4663/subject/62835/assessment/80984`);
    };

    return (
        <>
            <Header></Header>
            <div className="content-wrapper d-flex flex-wrap">
                <SideBar ></SideBar>
                <div className="sidebar-right">
                    <div className="wrap-box-right">
                        <div className="my-tickets-info-list Tickets-main-wrap">
                            <PageHeader title={<>My <span>Assessments</span></>} />
                           <MyAssessmentList />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyAssessment